module.exports = __webpack_public_path__ + "img/MS-J-6.ff9827da.svg";